var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 4.5L6.44169 7.11131C8.14074 8.074 8.85861 8.074 10.5577 7.11131L15.1663 4.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84352 9.48373C1.8871 11.5275 1.90889 12.5493 2.66298 13.3063C3.41706 14.0632 4.46656 14.0895 6.56556 14.1423C7.85921 14.1748 9.14014 14.1748 10.4338 14.1423C12.5328 14.0895 13.5823 14.0632 14.3364 13.3063C15.0905 12.5493 15.1123 11.5275 15.1558 9.48373C15.1699 8.8266 15.1699 8.1734 15.1558 7.51627C15.1123 5.47257 15.0905 4.45073 14.3364 3.69377C13.5823 2.93682 12.5328 2.91045 10.4338 2.85771C9.14014 2.82521 7.85921 2.82521 6.56555 2.85771C4.46656 2.91044 3.41706 2.93681 2.66297 3.69377C1.90889 4.45072 1.8871 5.47257 1.84351 7.51627C1.8295 8.1734 1.82951 8.8266 1.84352 9.48373Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.6e29334fc7aa46f614520f21ba8cea7a.svg";
export { ForwardRef as ReactComponent };